/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Remove_Passkey_TitleInputs */



/**
* | output |
* | --- |
* | "Remove passkey?" |
*
* @param {Partner_Security_Remove_Passkey_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_remove_passkey_title = /** @type {((inputs?: Partner_Security_Remove_Passkey_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Remove_Passkey_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkey entfernen?")
	return /** @type {LocalizedString} */ ("Remove passkey?")
});